import { normalize, toHours } from "duration-fns";
import getVideoId from "get-video-id";
import { _get, getTiktokUrl } from "./request";
import { useQuery } from "react-query";

const MINIMUM_TIP_AMOUNT = 1_000;
const MAXIMUM_TIP_AMOUNT = 100_000_000;

const DISBURSEMENT_RULE = {
  IDR: {
    min: 50_000,
    cut: 5_000,
  },
  PHP: {
    min: 500,
    cut: 50,
  },
  // TODO: ask mas rheza for the fee for jpy
  JPY: {
    min: 500,
    cut: 50,
  },
};

const getDisbursementRule = (currency) => {
  return DISBURSEMENT_RULE[currency];
};

const MIN_MAX = {
  IDR: {
    min: 1_000,
    max: 100_000_000,
  },
  PHP: {
    min: 10,
    max: 100_000,
  },
  JPY: {
    min: 10,
    max: 92090,
  },
};

const VENDOR_CUT = {
  dana: "1.69%",
  gopay: "2%",
  linkaja: "1.69%",
  ovo: "2.74%",
  qris: "0.7%",
  grabpay: "2.29%",
  gcash: "2.64%",
  paymaya: "2%",
  shopeepay: "2.29%",
  bca: "+Rp4.500",
  mandiri: "+Rp4.500",
  bri: "+Rp4.500",
  bni: "+Rp4.500",
  permata: "+Rp4.500",
  bjb: "+Rp4.500",
  bsi: "+Rp4.500",
  cimb: "+Rp4.500",
}

const VENDOR_CUT_RATES = {
    "dana": 0.01694,
    "gopay": 0.02041,
    "linkaja": 0.01694,
    "ovo": 0.02740,
    "qris": 0.00708,
    "bca": [0, 4500],
    "mandiri": [0, 4500],
    "bri": [0, 4500],
    "bni": [0, 4500],
    "permata": [0, 4500],
    "bjb": [0, 4500],
    "bsi": [0, 4500],
    "cimb": [0, 4500],
    "grabpay": 0.02291,
    "gcash": 0.02644,
    "paymaya": 0.02057,
    "shopeepay": 0.02291,
    "wechat_pay": 0.02291,
    "alipay": 0.02291,
    "inter_cc": 0.02291,
    "rakutenpay": 0.02291,
    "paypay": 0.02291,
    "linepay": 0.02291,
    "merpay": 0.02291,
}

// xendit doesn't charge qris fee for transactions below this amount (IDR)
// set this to 0 if you want to always use VENDOR_CUT["qris"]
const QRIS_FREE_VENDOR_CUT_THRESHOLD = Number(process.env.XENDIT_QRIS_FREE_VENDOR_CUT_THRESHOLD ?? 0);

const isQrisVendorCutFree = (type, amount) =>
  type === "qris" && Number(amount) > 0 && Number(amount) < QRIS_FREE_VENDOR_CUT_THRESHOLD;

const MIN_MAX_PRICE_WISHLIST = {
  IDR: {
    min: 1_000,
    max: 1_000_000_000,
  },

  PHP: {
    min: 10,
    max: 100_000,
  },
  JPY: {
    min: 10,
    max: 9_000_000,
  },
};

const MIN_MAX_WISHLIST_DELIVERY_FEE = {
  IDR: {
    min: 1000,
    max: 1_000_000_000,
  },

  PHP: {
    min: 100,
    max: 100_000,
  },
  JPY: {
    min: 10,
    max: 9_000_000,
  },
};

const MIN_MAX_REWARD_DONATION = {
  IDR: {
    min: 1_000,
    max: 9_900_000,
  },
  PHP: {
    min: 10,
    max: 90_000,
  },
  JPY: {
    min: 10,
    max: 85_000,
  },
};

const MIN_MAX_STORE_PRODUCT_PRICE = {
  IDR: {
    min: 1_000,
    max: 99_990_000,
  },
  PHP: {
    min: 10,
    max: 90_000,
  },
  JPY: {
    min: 10,
    max: 85_000,
  },
};

const MIN_MAX_DONATION_IDR = {
  dana: {
    min: 1_000,
    max: 10_000_000,
  },
  gopay: {
    min: 1_000,
    max: 10_000_000,
  },
  linkaja: {
    min: 1_000,
    max: 10_000_000,
  },
  ovo: {
    min: 1_000,
    max: 10_000_000,
  },
  qris: {
    min: 1_000,
    max: 10_000_000,
  },
  bca: {
    min: 10_000,
    max: 100_000_000,
  },
  mandiri: {
    min: 10_000,
    max: 30_000_000,
  },
  bri: {
    min: 10_000,
    max: 100_000_000,
  },
  bni: {
    min: 10_000,
    max: 50_000_000,
  },
  permata: {
    min: 10_000,
    max: 100_000_000,
  },
  bjb: {
    min: 10_000,
    max: 100_000_000,
  },
  bsi: {
    min: 10_000,
    max: 100_000_000,
  },
  cimb: {
    min: 10_000,
    max: 100_000_000,
  },
}

const MIN_MAX_DONATION_PHP = {
  gcash: {
    min: 10,
    max: 100_000,
  },
  paymaya: {
    min: 10,
    max: 100_000,
  },
  shopeepay: {
    min: 10,
    max: 100_000,
  },
  grabpay: {
    min: 10,
    max: 100_000,
  },
}

const MIN_MAX_DONATION_JPY = {
  wechat_pay: {
    min: 10,
    max: 100_000,
  },
  alipay: {
    min: 10,
    max: 100_000,
  },
  inter_cc: {
    min: 10,
    max: 100_000,
  },
  rakutenpay: {
    min: 10,
    max: 100_000,
  },
  paypay: {
    min: 10,
    max: 100_000,
  },
  linepay: {
    min: 10,
    max: 100_000,
  },
  merpay: {
    min: 10,
    max: 100_000,
  },
}

const getMinTipIDR = (gateway) => {
  return MIN_MAX_DONATION_IDR[gateway]?.min || MINIMUM_TIP_AMOUNT;
}

const getMaxTipIDR = (gateway) => {
  return MIN_MAX_DONATION_IDR[gateway]?.max || MAXIMUM_TIP_AMOUNT;
}

const getMinTipPHP = (gateway) => {
  return MIN_MAX_DONATION_PHP[gateway]?.min || MINIMUM_TIP_AMOUNT;
}

const getMaxTipPHP = (gateway) => {
  return MIN_MAX_DONATION_PHP[gateway]?.max || MAXIMUM_TIP_AMOUNT;
}

const getMinTipJPY = (gateway) => {
  return MIN_MAX_DONATION_JPY[gateway]?.min || MINIMUM_TIP_AMOUNT;
}

const getMaxTipJPY = (gateway) => {
  return MIN_MAX_DONATION_JPY[gateway]?.max || MAXIMUM_TIP_AMOUNT;
}

const getMinTip = (currency) => {
  return MIN_MAX[currency]["min"];
};

const getMaxTip = (currency) => {
  return MIN_MAX[currency]["max"];
};

const getMinWishlistPrice = (currency) => {
  return MIN_MAX_PRICE_WISHLIST[currency]["min"];
};

const getMaxWishlistPrice = (currency) => {
  return MIN_MAX_PRICE_WISHLIST[currency]["max"];
};

const getMinDeliveryFee = (currency) => {
  return MIN_MAX_WISHLIST_DELIVERY_FEE[currency]["min"];
};

const getMaxDeliveryFee = (currency) => {
  return MIN_MAX_WISHLIST_DELIVERY_FEE[currency]["max"];
};

const getMinRewardDonation = (currency) => {
  return MIN_MAX_REWARD_DONATION[currency]["min"];
};

const getMaxRewardDonation = (currency) => {
  return MIN_MAX_REWARD_DONATION[currency]["max"];
};

const getLocale = ({ currency }) => {
  switch (currency) {
    case "PHP":
      return "ph";
    case "JPY":
      return "ja";
    default:
      return "id";
  }
};

const formatMoney = (
  value,
  { formatWithSymbol = true, isShort = false, currency = "IDR" } = {}
) => {
  const MINIMUM_FRACTION_DIGITS_MAP = {
    IDR: 0,
    PHP: 2,
    JPY: 0,
  }
  let opts = {
    compactDisplay: "short",
    notation: "standard",
    currency: currency,
    style: "decimal",
    minimumFractionDigits: MINIMUM_FRACTION_DIGITS_MAP[currency],
  };

  if (isShort) {
    opts = { ...opts, notation: "compact" };
  }
  if (formatWithSymbol) {
    if (currency === "JPY") {
      // Special handling for JPY to use 円 symbol
      const formatted = new Intl.NumberFormat(getLocale({ currency }), {
        ...opts,
        style: "decimal"
      }).format(value);
      return `${formatted}円`;
    }
    opts = { ...opts, style: "currency" };
  }

  const ret = new Intl.NumberFormat(getLocale({ currency }), {
    ...opts,
  }).format(value);
  return ret.replace(/\s+/g, '');
};

function shortHandNumber(value) {
  let newValue = value;
  const suffixes = ["", "k", "M", "B", "T"];
  let suffixNum = 0;
  while (newValue >= 1000) {
    newValue /= 1000;
    suffixNum++;
  }

  newValue = parseFloat(newValue.toPrecision(3)) / 1;
  newValue += suffixes[suffixNum];
  return newValue;
}

const getTimeToAdd = (rules, data) => {
  const r = [...rules];
  r.sort((a, b) => {
    return b[0] - a[0];
  });
  let { amount } = data;

  amount = parseInt(amount);
  const filteredRules = r.filter(([amount, _]) => amount > 0);
  let denom = filteredRules.map(([amount, _]) => amount);
  let hours = filteredRules.map(([_, hours]) => hours);
  let minutes = filteredRules.map(([_, hours, minutes, seconds]) => minutes);
  let seconds = filteredRules.map(([_, hours, minutes, seconds]) => seconds);
  let change = denom.map(() => 0);

  for (let i = 0; i < denom.length; i++) {
    let c = denom[i];
    if (c <= 0) continue;
    while (amount >= c) {
      amount -= c;
      change[i] += 1;
    }
  }

  /**
   * This works because the rules are filtered
   */
  let timeToAdd = {
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  for (let i = 0; i < change.length; i++) {
    timeToAdd["hours"] += change[i] * hours[i] || 0;
    timeToAdd["minutes"] += change[i] * minutes[i] || 0;
    timeToAdd["seconds"] += change[i] * seconds[i] || 0;
  }

  return getRemainingTimeToDisplay(normalize(timeToAdd));
};

const getRemainingTimeToDisplay = (duration) => {
  const d = {};
  for (const [key, value] of Object.entries(duration)) {
    d[key] = parseInt(value) || 0;
  }

  let { hours = 0, minutes = 0, seconds = 0, ...otherTimes } = normalize(d);
  const hoursToAdd = toHours({ ...otherTimes });
  return { hours: hours + hoursToAdd, minutes, seconds };
};
const _getTiktokUrl = async (shortUrl) => {
  const { json: { data } } = await _get(`donations/get_tiktok_full_video?short_url=${shortUrl}`);
  return data.full_url
};



const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    return new Promise((resolve, reject) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(async () => {
        try {
          const result = await func(...args);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
  };
};

const _getTiktokUrlDebounced = debounce(async (shortUrl) => {
  const { json: { data } } = await _get(`donations/get_tiktok_full_video?short_url=${shortUrl}`);
  return data.full_url;
}, 1000);

const getTiktokVideoId = async (url = '') => {
  if (url.includes("vt.tiktok.com")) {
    const data = await _getTiktokUrlDebounced(url);
    url = data || url;
  }
  return getVideoId(url);
}

const getInstagramVideoId = (url) => {
  // Regular expression to match Instagram post URLs
  try {
    const regex = /(?:https?:\/\/)?(?:www\.)?instagram\.com(?:\/reels\/|\/reel\/)([^\/?]+)(?:\S+)?/i;
    const match = url.match(regex);
    if (!match) {
      return null
    }
    if (match[1]) {
      const postId = match[1];
      return postId;
    }
  } catch (e) {
    return null
  }

}


const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const getDaysDiff = (dateString) => {
  const updatedDate = new Date(dateString);
  const now = new Date();
  return Math.floor((now - updatedDate) / (24 * 60 * 60 * 1000));
};

export {
  formatMoney,
  getTimeToAdd,
  getRemainingTimeToDisplay,
  shortHandNumber,
  MIN_MAX,
  MAXIMUM_TIP_AMOUNT,
  MINIMUM_TIP_AMOUNT,
  getMaxTip,
  getMinTip,
  getMinTipIDR,
  getMaxTipIDR,
  getMinTipPHP,
  getMaxTipPHP,
  getMinTipJPY,
  getMaxTipJPY,
  getMinWishlistPrice,
  getMaxWishlistPrice,
  getMinDeliveryFee,
  getMaxDeliveryFee,
  getMinRewardDonation,
  getMaxRewardDonation,
  getLocale,
  getDisbursementRule,
  VENDOR_CUT,
  VENDOR_CUT_RATES,
  isQrisVendorCutFree,
  getTiktokVideoId,
  getInstagramVideoId,
  blobToBase64,
  getDaysDiff,
  MIN_MAX_STORE_PRODUCT_PRICE
};
